/* eslint-disable no-else-return */
/* eslint-disable import/no-extraneous-dependencies */
import { Card } from 'antd';
import styled from 'styled-components';
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
} from 'chart.js';
import PropTypes from 'prop-types';
import { Line } from 'react-chartjs-2';
import { LoadingAnimation } from 'components/common';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const CardContainer = styled(Card)`
	width: 100%;
	height: 270px;
`;

const CardTitle = styled.div`
	font-weight: 500;
	font-size: 16px;
`;

function RegularTrips({ regularTrips, isLoading }) {
	const ChartOptions = {
		responsive: true,
		maintainAspectRatio: false,
		elements: {
			point: {
				borderWidth: 0,
				radius: 5,
				backgroundColor: 'rgba(0,0,0,0)',
			},
		},
		stacked: false,
		plugins: {
			legend: {
				align: 'end',
				labels: {
					boxWidth: 10,
					boxHeight: 10,
				},
			},
			datalabels: {
				display: false,
			},
			tooltip: {
				enabled: true,
				usePointStyle: true,
				callbacks: {
					title: (data) => {
						console.log('data ', data[0]);
						return data[0]?.dataset?.tooltips[data[0]?.dataIndex];
					},
				},
			},
		},
		scales: {
			x: {
				border: {
					dash: [3, 6],
					display: false,
				},
				grid: {
					color: '#CECECE',
				},
			},
			y: {
				type: 'linear',
				display: true,
				beginAtZero: true,
				position: 'left',
				border: {
					display: false,
					dash: [3, 6],
				},
				grid: {
					color: '#CECECE',
				},
			},
		},
	};
	const labels =
		regularTrips &&
		regularTrips.map((res) => {
			if (res.month) {
				return res.month;
			} else if (res.date) {
				return res.date;
			} else {
				return res.day;
			}
		});

	const data = {
		labels,
		datasets: [
			{
				label: 'Acual Trip Count',
				tooltips: regularTrips && regularTrips.map((res) => res.tooltip),
				data: regularTrips && regularTrips.map((res) => res.count),
				// data: donutList && donutList.map((res) => res.percent),
				borderColor: '#FF8800',
				backgroundColor: '#FF8800',
				yAxisID: 'y',
			},
		],
	};

	return (
		<CardContainer>
			{isLoading ? (
				<div style={{ width: '250px', margin: '0 auto' }}>
					<LoadingAnimation visible={isLoading} animationID="RegularTrips" />
				</div>
			) : (
				<span style={{ height: '200px' }}>
					<CardTitle>Regular Trip Trend</CardTitle>
					<Line options={ChartOptions} data={data} />
				</span>
			)}
		</CardContainer>
	);
}

RegularTrips.propTypes = {
	regularTrips: PropTypes.array,
	isLoading: PropTypes.bool,
};

export default RegularTrips;
